import angular from 'angular';
import ReadMore from './readMore';

export default angular
  .module('components.readMore', [])
  .component('readMore', ReadMore).name;
